import * as React from "react";
import styles from "./close-component.module.scss";
const iconClose = "https://site.appchoose.io/external/icons/ic-close-white.svg";

interface ICloseComponent {
  display: boolean;
  onClose: () => void;
}

export default class CloseComponent extends React.PureComponent<
  ICloseComponent,
  {}
> {
  public onClose = () => {
    this.props.onClose();
  };
  public render() {
    return (
      <div className={`${styles.close} animated fadeIn`} onClick={this.onClose}>
        <img alt="close" src={iconClose} />
      </div>
    );
  }
}
